import type { ToastState, IToast } from './types'
import type { PayloadAction } from '@reduxjs/toolkit'

import { v4 as uuidv4 } from 'uuid'

import { createSlice } from '@redux'

import { NAME } from './constants'

export const initialState: ToastState = {
  toasts: [],
}

export const slice = createSlice(NAME, {
  name: NAME,
  initialState,
  reducers: {
    addToast(state, action: PayloadAction<IToast>) {
      const id = uuidv4()
      state.toasts.push({ ...action.payload, id })
    },
    closeToast(state, action: PayloadAction<string>) {
      state.toasts = state.toasts.filter((toast) => toast.id !== action.payload)
    },
  },
})

export const reducer = slice.reducer
export * from './selectors'
export const actions = slice.actions

export default { [NAME]: reducer }
